{ wrapRequest, wrapRequestJSON } = require 'utils/request'
Bacon = require 'baconjs'
client = require 'api/auth'
R = require 'ramda'

module.exports =
  search: (query) ->
    wrapRequest $.ajax
    url: SERVICE_URL
    type: 'POST'
    data:
      query: JSON.stringify query

  searchGraphql: (url, params) ->
    console.log "[LOAD RESTAURANT GRAPHQL]", url if window.apiLogging
    wrapRequestJSON client.api(url, 'post', params), "[create event done]"

  toESQuery: (term) ->
    lowerQueryStr = term.toLowerCase()
    conditions = [
      {field: "name", op: "starts_with", value: lowerQueryStr}
    ]
    required_data = "query ($restaurant_id: Int!) {
      restaurant(id: $restaurant_id) {
        id
        name
        locations {
        id
        address {
          city
          country
          street
          zip
        }
      }
      }
    }"

    channel_permalink = "zuppler"

    params = R.mergeAll [conditions: conditions, required_data: required_data, channel_permalink: channel_permalink]

    url = "#{RESTAURANTS_SVC_API5}/v5/restaurants/search"

    console.log "[SEARCH RESTAURANT]", url if window.apiLogging
    Bacon.fromPromise wrapRequestJSON client.api(url, 'post', params), "[search event done]"

  toV6Query: (term) ->
    url = "#{RESTAURANTS_SVC_API5}/v6/restaurants/search"
    params =
      name: term.toLowerCase()

    console.log "[SEARCH RESTAURANT]", url if window.apiLogging
    Bacon.fromPromise wrapRequestJSON client.api(url, 'post', params), "[search event done]"


